import React, { createContext, useContext, useEffect, useRef } from "react"
import JWTApi, { IUser } from "../../libs/login/JWTApi"
import LoginDlg from "./LoginDlg"
import { useOverlay } from "../Overlay/OverlayProvider"
import Form from "../Form/Form"

type TLoginContext = {
    login:(onLogin?:Function) => void
    logout:() => void
}

interface TLoginContextProps {
    api:JWTApi
    children:JSX.Element
    loginDialog?:JSX.Element
    required?:boolean
    onAuth?:(user:IUser) => void
}

const LoginContext = createContext<TLoginContext>({} as any)
export const useLogin = () => useContext(LoginContext)

export default function LoginProvider(props:TLoginContextProps) {
    const {api} = props
    const {addOverlay,popOverlay,hasOverlay} = useOverlay()

    const login = (onLogin?:Function) => {
        if (hasOverlay("loginDialog")) return
        addOverlay("loginDialog", {children:<Form><LoginDlg overlayId="loginDialog" api={api} onLogin={onLogin}/></Form>, className:"dialog", modal:!!props.required})
    }

    const onAuth = async (user:IUser|null) => {
        if (!user && props.required) login()
        else if (!!user) {
            popOverlay("loginDialog")
            props.onAuth?.(user)
        }
    }
    // const onAuthRef = useRef(onAuth)
    // useEffect(() => { onAuthRef.current = onAuth})

    const logout = () => props.api.logout()

    useEffect(() => {
        // const handleAuth = (user:IUser|null) => onAuthRef.current(user)
        api.on("auth", onAuth)
        // api.on("auth", handleAuth)
        if (!api.isLoggedIn && props.required) login()
        return () => { api.removeListener("auth", onAuth) }
    }, [])

    return <LoginContext.Provider value={{login,logout}}>
        {props.children}
    </LoginContext.Provider>
}